import strings from 'strings';

import { COPIES, RESPONSE_STATUSES } from './MatchMakingTable.constants';

export const getMatchEmptyStateLabels = ({ entityType, responseError, responseStatus }) => {
  if (!responseStatus) {
    return {
      title: COPIES.matchMakingNotStarted.title,
      subtitle: strings.formatString(COPIES.matchMakingNotStarted.subtitle, {
        entityType
      })
    };
  }

  if (responseStatus === RESPONSE_STATUSES.failed) {
    return {
      title: responseError?.title || COPIES.error.title,
      subtitle: responseError?.message || COPIES.error.subtitle
    };
  }

  if (responseError) {
    return {
      title: COPIES.error.title,
      subtitle: responseError?.message || COPIES.error.subtitle
    };
  }

  return {
    title: COPIES.emptyState.title,
    subtitle: COPIES.emptyState.subtitle
  };
};
